// src/components/auth/ForgotPassword.jsx
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './auth.css';
import logo from '../../assets/logo3.png';

const ForgotPassword = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setMessage('');
        setLoading(true);

        try {
            const response = await fetch('http://localhost:5001/api/auth/forgot-password', {
                method: 'POST',
                headers: { 
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
                body: JSON.stringify({ email })
            });

            const data = await response.json();

            if (response.ok) {
                setMessage('Password reset link has been sent to your email! Check your inbox.');
                setEmail('');
                
                // Optional: Redirect to login after 5 seconds
                setTimeout(() => {
                    navigate('/login', { 
                        state: { 
                            message: 'Check your email for the password reset link.' 
                        }
                    });
                }, 5000);
            } else {
                setError(data.error || 'Failed to send reset email. Please try again.');
            }
        } catch (err) {
            console.error('Forgot password error:', err);
            setError('Network error. Please check if the server is running.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth__page">
            <div className="auth__container">
                {/* Form Side */}
                <div className="auth__box">
                    <div className="auth__header">
                        <img src={logo} alt="Logo" className="auth__logo" />
                        <h2>Reset Your Password</h2>
                        <p>Enter your email and we'll send you a reset link</p>
                    </div>

                    {message && (
                        <div className="auth__success" style={{ 
                            background: 'rgba(72, 187, 120, 0.1)',
                            border: '1px solid rgba(72, 187, 120, 0.3)',
                            color: '#059669',
                            padding: '1rem',
                            borderRadius: '0.75rem',
                            marginBottom: '1.5rem',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '0.5rem'
                        }}>
                            <i className="bx bx-check-circle"></i>
                            {message}
                        </div>
                    )}

                    {error && (
                        <div className="auth__error">
                            <i className="bx bx-error-circle"></i>
                            {error}
                        </div>
                    )}

                    <form onSubmit={handleSubmit} className="auth__form">
                        <div className="auth__field">
                            <input
                                type="email"
                                name="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Enter your email address"
                                required
                                disabled={loading || message}
                            />
                            <i className="bx bx-envelope"></i>
                        </div>

                        <button 
                            type="submit" 
                            className="auth__button button button--flex" 
                            disabled={loading || message}
                        >
                            {loading ? (
                                <>
                                    <span className="spinner"></span>
                                    Sending...
                                </>
                            ) : (
                                <>
                                    <i className="bx bx-mail-send"></i>
                                    Send Reset Link
                                </>
                            )}
                        </button>
                    </form>

                    <div className="auth__footer">
                        <p>
                            Remember your password?{' '}
                            <Link to="/login">Sign In</Link>
                        </p>
                        <Link to="/" style={{ marginTop: '1rem', display: 'inline-block' }}>
                            ← Back to Home
                        </Link>
                    </div>
                </div>

                {/* Side Panel */}
                <div className="auth__side">
                    <h3>Security First</h3>
                    <p>We take your security seriously. The reset link will expire in 1 hour for your protection.</p>
                    
                    <ul className="auth__features">
                        <li>
                            <i className="bx bx-shield"></i>
                            <span>Secure password reset process</span>
                        </li>
                        <li>
                            <i className="bx bx-time"></i>
                            <span>Time-limited reset links (1 hour)</span>
                        </li>
                        <li>
                            <i className="bx bx-lock"></i>
                            <span>Encrypted password storage</span>
                        </li>
                        <li>
                            <i className="bx bx-check-shield"></i>
                            <span>Email verification required</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;